<template>
  <div>
    <v-row justify="center">
      <v-dialog
        v-model="showDialog"
        persistent
        scrollable
        max-width="600"
      >
        <v-card>
          <v-card-title class="text-h5">
            Errores encontrados
          </v-card-title>
          <v-card-text>
            <ul>
              <li v-for="(error, idx) in errors" :key="idx" >
                <strong>Fila: </strong> {{ error.row }}
                <br>
                <strong>Detalle: </strong>
                <ul>
                  <li v-for="(e, i) in error.error_details" :key="i">
                    Columna: {{e.column}}
                    <br>
                    Error: {{e.error_message}}
                    <br>
                    Tipo de Error: {{e.error_type}}
                  </li>
                </ul>
              </li>
            </ul>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              outlined
              @click="closeDialogError"
              :disabled="loading"
            >
              Cerrar
            </v-btn>
            <v-btn
              color="blue darken-1"
              outlined
              @click="downloadFile"
              :loading="loading"
              :disabled="loading"
            >
              Descargar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import uris from '../../../utils/uris'
import axios from '../../../utils/axiosWrapperAutoservicio'
import eventBus from '../../../utils/eventBus'

export default {
  name: 'validation-dialog-error',
  data () {
    return {
      loading: false,
      showDialog: false,
      errors: [],
      file: []
    }
  },
  created () {
    eventBus.$off('open-dialog-autoservicio-error')
    eventBus.$on('open-dialog-autoservicio-error', (data) => {
      this.openDialogError(data.showDialog, data.errors, data.file)
    })
  },
  methods: {
    openDialogError (showDialog, errors, file) {
      this.showDialog = showDialog
      this.errors = errors
      this.file = file
    },
    closeDialogError () {
      this.showDialog = false
    },
    downloadFile () {
      this.loading = true
      let formData = new FormData()
      formData.append('excel_file', this.file)
      formData.append('data', JSON.stringify(this.errors))
      axios.post(uris.URL_AUTOSERVICIO_GET_ERROR_TEMPLATE,
        formData
        , {
          responseType: 'blob'
        })
        .then((response) => {
          const filename = response.headers.filename
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          link.remove()
        })
        .catch((err) => {
          console.warn('No se ha podido obtener data de errores', err)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/autoservicios/validation/validation-dialog-error.vue